import type { FC } from "react";

import { cn } from "@/ui/lib";
import {
  ITEM_ACTIONS_CLASS,
  TItemActionsProps,
} from "@/ui/components/data-display/Item/Item.config";

export const ItemActions: FC<TItemActionsProps> = (
  {
    className,
    children,
    ...props
  },
) => (
  <div
    {...props}
    data-component="ItemActions"
    className={cn(ITEM_ACTIONS_CLASS, className)}
  >
    { children }
  </div>
);

ItemActions.displayName = "ItemActions";
